import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { langStorage } from 'data/app/AppStorageContext';

const resources = {
  en: {},
  nb: {},
};

export default i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: langStorage.get(),
    fallbackLng: 'nb',
    interpolation: {
      escapeValue: false,
    },
  });
